export const css = {
    root: '_8g8XMFeP',
    dateGrid: '_1fGQchKW',
    weekday: '_2pA6hIXE',
    date: '_3YFf3Ply',
    abbr: '_3iIiJjQh',
    todayDate: 'd0AjQPsT',
    inactiveDate: '_2tjvqHVh',
    selectedDate: '_37_5NiQl',
    topMatter: '_1IRSPiy2',
    monthTrigger: 'cY71WRWy',
    yearTrigger: '_28wTLb1P',
    previous: '_2xwjKJx1',
    next: '_2LzTAUu9',
    monthTriggerActive: '_3Qfvx1oT',
    yearTriggerActive: '_3fD7ToH9',
    calendarPagingIcon: 'GlYmSl6Z _29RvxPMs',
    monthGrid: 'mZE0Btnb',
    yearGrid: '_3z6tZ5Yr',
    monthFields: '_343XAn1w',
    yearFields: '_2ulJ97sy',
    monthRadio: '_2CPSGjNH',
    yearRadio: '_2w-dxZy8',
    monthRadioLabel: '_3oTerlZF',
    yearRadioLabel: '_2IkO4SIo',
    monthRadioChecked: '_3pYfvgPp',
    yearRadioChecked: '_2b05yoLN',
    monthRadioInput: 'wTydQN-x',
    yearRadioInput: '_1b6Vus8O',
    ' _key': 'afcpe-theme/dojo/calendar'
};
export default css;
